module.exports = __webpack_public_path__ + "static/ogw2-bbdef4f927b3ca7837e24e042f17b321.jpg";